module.exports = __webpack_public_path__ + "static/09-blue-zoom-57a12063473a515599c431524433d2ae.jpg";